import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constants/constant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var UploadProfileLogoAction = function () {

}


UploadProfileLogoAction.prototype = {

	upload: function (data) {
		restClient.uploadWhitelabelImage(data, function (error, response) {
			if (response != null) {
				response.status = 200;
				AppDispatcher.dispatch({
					actionType: Constant.PROFILE_LEVEL_LOGO_UPLOAD,
					data: response
				});
			} else {
				// A real network failure (offline, timeout, CORS block) leaves
				// axios's error.response undefined - without this branch,
				// neither side of the original if/else would fire and nothing
				// would ever be dispatched, leaving callers (e.g. a per-image
				// upload spinner) waiting forever with no error shown either.
				AppDispatcher.dispatch({
					actionType: Constant.PROFILE_LEVEL_LOGO_UPLOAD,
					data: error || { data: { message: 'Network error - please try again' } }
				});
			}
		})
	}
}


export default new UploadProfileLogoAction();